// @generated source--
// scripts/generate-bits/file-generators/component-story-map.generator.ts

export const pipeStoryMap: {
  [name: string]: {
    path: string;
    tags: string[];
    internalOnly: boolean;
    stories: string[];
  };
} = {
  'bypass-security-trust-resource-url': {
    path: '',
    tags: ['url'],
    internalOnly: false,
    stories: ['default'],
  },
  'compact-number': {
    path: '',
    tags: ['numeric'],
    internalOnly: false,
    stories: ['default'],
  },
  'freelancer-currency': {
    path: '',
    tags: ['numeric'],
    internalOnly: false,
    stories: ['default'],
  },
  'date-range': {
    path: '',
    tags: ['date', 'time'],
    internalOnly: false,
    stories: ['default'],
  },
  duration: {
    path: '',
    tags: ['time'],
    internalOnly: false,
    stories: ['default'],
  },
  'dynamic-time': {
    path: '',
    tags: ['time'],
    internalOnly: false,
    stories: ['default'],
  },
  emoji: {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
  },
  'file-size': {
    path: '',
    tags: ['file'],
    internalOnly: false,
    stories: ['default'],
  },
  'is-online': {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
  },
  location: {
    path: '',
    tags: ['location'],
    internalOnly: false,
    stories: ['default'],
  },
  'pascal-case': {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
  },
  sanitise: {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
  },
  'truncate-filename': {
    path: '',
    tags: ['file'],
    internalOnly: false,
    stories: ['default'],
  },
};
